import React, { useId } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { dashboardLayout } from "./layoutTokens";

export function DashboardFormSection({ title, description, children }: { title: string; description?: string; children: React.ReactNode }) {
  const titleId = useId();
  return <Box component="section" aria-labelledby={titleId} sx={{ minWidth: 0 }}>
    <Typography id={titleId} component="h3" variant="subtitle1">{title}</Typography>
    {description && <Typography variant="body2" color="text.secondary" sx={{ mt: .5, maxWidth: "72ch" }}>{description}</Typography>}
    <Stack spacing={2} sx={{ mt: 2, minWidth: 0 }}>{children}</Stack>
  </Box>;
}

export function DashboardHeading({ title, description, icon, actions }: { title: string; description?: string; icon?: React.ReactNode; actions?: React.ReactNode }) {
  return <Stack direction={{ xs: "column", md: "row" }} flexWrap="wrap" gap={2} justifyContent="space-between" alignItems={{ xs: "stretch", md: "center" }} sx={{ mb: 3 }}>
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", flex: { md: "1 1 260px" }, minWidth: 0 }}>
      {icon && <Box sx={{ width: 42, height: 42, flexShrink: 0, display: "grid", placeItems: "center", bgcolor: "action.selected", color: "primary.main", borderRadius: "10px 10px 10px 3px", "& svg": { width: 21, height: 21 } }}>{icon}</Box>}
      <Box sx={{ minWidth: 0 }}><Typography component="h1" sx={{ fontSize: { xs: 24, md: 28 }, lineHeight: 1.3, fontWeight: 700, letterSpacing: "-.035em" }}>{title}</Typography>
        {description && <Typography color="text.secondary" variant="body2" sx={{ mt: .75, maxWidth: "72ch" }}>{description}</Typography>}
      </Box>
    </Box>
    {actions && <Stack direction="row" flexWrap="wrap" gap={1} alignItems="center" sx={{ minWidth: 0, "& .MuiButton-root": { whiteSpace: "normal" } }}>{actions}</Stack>}
  </Stack>;
}

export default function DashboardPage({ children, title, description, icon, actions }: { children: React.ReactNode; title: string; description?: string; icon?: React.ReactNode; actions?: React.ReactNode }) {
  return <Box sx={{ p: dashboardLayout.pagePadding, maxWidth: dashboardLayout.pageMaxWidth, width: "100%", mx: "auto", minWidth: 0 }}>
    <DashboardHeading title={title} description={description} icon={icon} actions={actions} />{children}
  </Box>;
}
